import * as React from 'react';

import useMedia from 'use-media';

import { theme } from '@notino/react-styleguide';
import { GetProductsByIdBatchedQuery } from '@notino/shared/definitions/types';

import { RecommendationPlacement } from '@utils/tracking/recommendationPlacement';
import { RecommendationAttributesInput } from '@utils/tracking/recommendationTracking';

import { ProductsSectionContent } from './ProductSectionContent';
import { ProductsSectionPlaceholder } from './ProductsSectionPlaceholder';

interface IProductListContentParams {
  loading: boolean;
  listLabel: string;
  inView: boolean;
  data: GetProductsByIdBatchedQuery | undefined;
  trackProductClick: boolean;
  trackProductImpression: boolean;
  attributionToken?: string;
  itemsPerSlide?: number;
  className?: string;
  isSponsored?: boolean;
  onProductClick?: (productId: string) => void;
  trackProductClickOnContextMenu?: boolean;
  onProductImpression?: (productId: string) => void;
  onProductBasketChange?: (productId: string, quantity: number) => void;
  onProductWishlist?: (productId: string, wishlisted: boolean) => void;
  recommendationPlacement?: RecommendationPlacement;
  recommendationAttributes?: RecommendationAttributesInput;
}

export const ProductListContent = ({
  loading,
  listLabel,
  inView,
  data,
  trackProductClick,
  trackProductImpression,
  attributionToken,
  itemsPerSlide: _itemsPerSlide,
  className,
  isSponsored,
  onProductClick,
  trackProductClickOnContextMenu,
  onProductImpression,
  onProductBasketChange,
  onProductWishlist,
  recommendationPlacement,
  recommendationAttributes,
}: IProductListContentParams) => {
  const isBigScreen = useMedia(`(min-width: ${theme.breakpoints.xxl}rem)`);
  const itemsPerSlide = _itemsPerSlide ?? (isBigScreen ? 5 : 4);

  if (inView && !loading && data) {
    return (
      <ProductsSectionContent
        className={className}
        data={data}
        listLabel={listLabel}
        trackProductClick={trackProductClick}
        trackProductImpression={trackProductImpression}
        itemsPerSlide={itemsPerSlide}
        attributionToken={attributionToken}
        isSponsored={isSponsored}
        onProductClick={onProductClick}
        trackProductClickOnContextMenu={trackProductClickOnContextMenu}
        onProductImpression={onProductImpression}
        onProductBasketChange={onProductBasketChange}
        onProductWishlist={onProductWishlist}
        recommendationPlacement={recommendationPlacement}
        recommendationAttributes={recommendationAttributes}
      />
    );
  }

  return (
    <ProductsSectionPlaceholder
      itemsPerSlide={itemsPerSlide}
      listLabel={listLabel}
    />
  );
};
